module.exports = __webpack_public_path__ + "static/media/default-background.711f03b7.jpg";